'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastPlayedGames = exports.setLastPlayedGame = exports.getFavorites = exports.removeFavorite = exports.setFavorite = undefined;

var _casino = require('tg-core-api/lib/casino');

var _casino2 = _interopRequireDefault(_casino);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setFavorite = exports.setFavorite = function setFavorite(playerSessionID, gameId, tableId, setLinkedGames) {
  return (0, _action.makeApiCallAction)('SET_FAVORITE', _casino2.default.setFavorite(playerSessionID, gameId, tableId, setLinkedGames));
};

var removeFavorite = exports.removeFavorite = function removeFavorite(playerSessionID, gameId, tableId, removeLinkedGames) {
  return (0, _action.makeApiCallAction)('REMOVE_FAVORITE', _casino2.default.removeFavorite(playerSessionID, gameId, tableId, removeLinkedGames));
};

var getFavorites = exports.getFavorites = function getFavorites(playerSessionID) {
  return (0, _action.makeApiCallAction)('GET_FAVORITES', _casino2.default.getFavorites(playerSessionID));
};

var setLastPlayedGame = exports.setLastPlayedGame = function setLastPlayedGame(playerSessionID, gameId, tableId, setLinkedGames) {
  return (0, _action.makeApiCallAction)('SET_LAST_PLAYED_GAME', _casino2.default.setLastPlayedGame(playerSessionID, gameId, tableId, setLinkedGames));
};

var getLastPlayedGames = exports.getLastPlayedGames = function getLastPlayedGames(playerSessionID, platform) {
  return (0, _action.makeApiCallAction)('GET_LAST_PLAYED_GAMES', _casino2.default.getLastPlayedGames(playerSessionID, platform));
};

exports.default = {
  setFavorite: setFavorite,
  removeFavorite: removeFavorite,
  getFavorites: getFavorites,
  setLastPlayedGame: setLastPlayedGame,
  getLastPlayedGames: getLastPlayedGames
};